import AdvisorView from './AdvisorView';

export default AdvisorView;
